import { useEffect, useRef } from 'react'
import type { TextareaHTMLAttributes } from 'react'

/**
 * Textarea с автоматической подстройкой высоты под содержимое — без скролла.
 * Высота пересчитывается на каждый input через `scrollHeight`. Минимальная
 * высота — как обычно у 2 строк (определяется через CSS `min-h-*`).
 *
 * Используй вместо `<textarea rows=... />` там, где важно сразу видеть весь
 * текст (заметки к квотам, длинные описания), но не хочется скролла внутри.
 */
export function AutoTextarea(
  props: TextareaHTMLAttributes<HTMLTextAreaElement> & { minRows?: number },
) {
  const { className = '', value, minRows = 2, style, ...rest } = props
  const ref = useRef<HTMLTextAreaElement | null>(null)

  const resize = () => {
    const el = ref.current
    if (!el) return
    // Сбрасываем высоту — иначе scrollHeight даст текущую, не минимальную.
    el.style.height = 'auto'
    el.style.height = `${el.scrollHeight}px`
  }

  useEffect(resize, [value])
  useEffect(() => {
    resize()
    // Подстраиваемся при первом маунте (если initial value уже не помещается).
  }, [])

  return (
    <textarea
      ref={ref}
      value={value}
      onInput={resize}
      rows={minRows}
      style={{ overflow: 'hidden', resize: 'none', ...style }}
      className={className}
      {...rest}
    />
  )
}
